
export const GET_USER_SIGN_IN_SUCCESS = "GET_USER_SIGN_IN_SUCCESS";
export const GET_USER_SIGN_IN_FAIL = "GET_USER_SIGN_IN_FAIL";
export const GET_USER_SIGN_IN_REQUEST = "GET_USER_SIGN_IN_REQUEST";
export const GET_USER_SIGN_UP_SUCCESS = "GET_USER_SIGN_UP_SUCCESS";
export const GET_USER_SIGN_UP_FAIL = "GET_USER_SIGN_UP_FAIL";
export const GET_USER_SIGN_UP_REQUEST = "GET_USER_SIGN_UP_REQUEST";
export const GET_USER_SIGN_OUT_SUCCESS = "GET_USER_SIGN_OUT_SUCCESS";
export const GET_USER_SIGN_OUT_FAIL = "GET_USER_SIGN_OUT_FAIL";
export const GET_USER_SIGN_OUT_REQUEST = "GET_USER_SIGN_OUT_REQUEST";
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS";
export const GET_USER_PROFILE_FAIL = "GET_USER_PROFILE_FAIL";
export const GET_USER_PROFILE_REQUEST = "GET_USER_PROFILE_REQUEST";
export const GET_USER_PROFILE_UPDATE_SUCCESS = "GET_USER_PROFILE_UPDATE_SUCCESS";
export const GET_USER_PROFILE_UPDATE_FAIL = "GET_USER_PROFILE_UPDATE_FAIL";
export const GET_USER_PROFILE_UPDATE_REQUEST = "GET_USER_PROFILE_UPDATE_REQUEST";
export const GET_USER_PROFILE_UPDATE_RESET = "GET_USER_PROFILE_UPDATE_RESET";
export const GET_DASHBOARD_SUCCESS = "GET_DASHBOARD_SUCCESS";
export const GET_DASHBOARD_FAIL = "GET_DASHBOARD_FAIL";
export const GET_DASHBOARD_REQUEST = "GET_USER_PROFILE_REQUEST";
export const GET_BANK_ACCOUNT_SUCCESS = "GET_BANK_ACCOUNT_SUCCESS";
export const GET_BANK_ACCOUNT_FAIL = "GET_BANK_ACCOUNT_FAIL";
export const GET_BANK_ACCOUNT_REQUEST = "GET_BANK_ACCOUNT_REQUEST";
export const GET_BANK_ACCOUNT_UPDATE_SUCCESS = "GET_BANK_ACCOUNT_UPDATE_SUCCESS";
export const GET_BANK_ACCOUNT_UPDATE_FAIL = "GET_BANK_ACCOUNT_UPDATE_FAIL";
export const GET_BANK_ACCOUNT_UPDATE_REQUEST = "GET_BANK_ACCOUNT_UPDATE_REQUEST";

